import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MaterialStatus, MaterialStatusQuery } from '@fusion-advantage/backcompat'

export enum MaterialStateStatus {
	// currently looking up status in the database
	QueryPending = 'QueryPending',
}

export const materialStatusQueryKey = (query: MaterialStatusQuery) => {
	return query.area + '|' + query.id + '|' + query.type
}

export interface AsyncResultSliceState {
	materialStatus: {
		[queryKey: string]: MaterialStatus|MaterialStateStatus
	}
}

const initialState: AsyncResultSliceState = {
	materialStatus: {},
}

const asyncResultSlice = createSlice({
	name: 'asyncResult',
	initialState,
	reducers: {
		setAsyncResultMaterialStatus(state, action: PayloadAction<{query: MaterialStatusQuery, status: MaterialStatus|MaterialStateStatus}>) {
			const queryKey = materialStatusQueryKey(action.payload.query)
			console.debug(`setAsyncResultMaterialStatus [${queryKey}] = ${action.payload.status}`)
			state.materialStatus[queryKey] = action.payload.status
		},
	},
})

export const { setAsyncResultMaterialStatus } = asyncResultSlice.actions
export default asyncResultSlice.reducer
